"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiVideoSlotReelContainer = void 0;
var _pixiGame = require("@dragon/pixi-game");
var _pixi = require("pixi.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Standard Container for video slot reels.
 * Holds the Reel Background, foreground, Reels etc. 
 * Note it offers multiple layered containers to best fit the needs of the game.
 *  */
var PixiVideoSlotReelContainer = exports.PixiVideoSlotReelContainer = /*#__PURE__*/function (_PixiGameComponent) {
  function PixiVideoSlotReelContainer(name, maskWidth, maskHeight, position) {
    var _this;
    _classCallCheck(this, PixiVideoSlotReelContainer);
    _this = _callSuper(this, PixiVideoSlotReelContainer, [name, position]);
    /**
     * Furthest back. the background
     */
    _defineProperty(_this, "reelsBackgroundContainer", new _pixi.Container());
    /**
     * Reels container, where the reels are placed.
     */
    _defineProperty(_this, "reelsContainer", new _pixi.Container());
    /**
     * Foreground of reels, elements of reel frame that should appear on top of symbols during spins etc. if something should be slightly above the symbols during spin
     */
    _defineProperty(_this, "reelsForegroundContainer", new _pixi.Container());
    /**
     * Win presentations, win lines etc. above all others.
     */
    _defineProperty(_this, "reelsPresentationContainer", new _pixi.Container());
    _defineProperty(_this, "_maskSprite", void 0);
    _this.reelsBackgroundContainer.name = "ReelsBackgroundContainer";
    _this.reelsContainer.name = "ReelsContainer";
    _this.reelsForegroundContainer.name = "ReelsForegroundContainer";
    _this.reelsPresentationContainer.name = "ReelsPresentationContainer";

    //#region Setup Mask for reels
    var maskG = new _pixi.Graphics();
    maskG.beginFill(0xff0000);
    maskG.drawRect(0, 0, maskWidth, maskHeight);
    maskG.endFill();
    var maskT = _this.application.renderer.generateTexture(maskG, {
      scaleMode: _pixi.SCALE_MODES.LINEAR,
      resolution: 1
    });
    _this._maskSprite = new _pixi.Sprite(maskT);
    _this._maskSprite.name = "ReelMask";
    _this.reelsContainer.addChild(_this._maskSprite);
    _this.reelsContainer.mask = _this._maskSprite;
    // to adjust the placement of the mask, access the maskSprite and adjust its position.

    //#endregion

    // Order here is very important, the first added will be the furthest back.
    _this.addChild(_this.reelsBackgroundContainer, _this.reelsContainer, _this.reelsForegroundContainer, _this.reelsPresentationContainer);
    return _this;
  }

  /**
   * Override to handle Quickstop/slam stop indication.
   */
  _inherits(PixiVideoSlotReelContainer, _PixiGameComponent);
  return _createClass(PixiVideoSlotReelContainer, [{
    key: "quickStop",
    value: function quickStop() {}
  }, {
    key: "maskOn",
    value: function maskOn() {
      this.reelsContainer.mask = this._maskSprite;
    }
  }, {
    key: "maskOff",
    value: function maskOff() {
      this.reelsContainer.mask = null;
    }
  }]);
}(_pixiGame.PixiGameComponent);
//# sourceMappingURL=PixiVideoSlotReelContainer.js.map